import { useCallback, useEffect } from "react"
import { Button, message } from "antd"
import { CloseOutlined } from "@ant-design/icons"

interface ConnectionLostAlertProps {
  setConnectionLost: (lost: boolean) => void
}

export function ConnectionLostAlert({ setConnectionLost }: ConnectionLostAlertProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const key = "connection-lost"

  const handleClose = useCallback(() => {
    messageApi.destroy(key)
    setConnectionLost(false)
  }, [messageApi, setConnectionLost])

  useEffect(() => {
    messageApi.open({
      key,
      type: "warning",
      content: (
        <>
          <span>
            Live updates aren&apos;t available right now. To check for changes by other users, refresh the page.
          </span>
          <Button type="text" size="small" icon={<CloseOutlined />} onClick={handleClose} />
        </>
      ),
      duration: 0, // Message won't auto-close
    })
  }, [messageApi, handleClose])

  return contextHolder
}
